export const SEEDN_USER_ID_LIST = [
  1, 21, 496, 502, 2374, 3534, 3535, 3536, 3349, 1242, 1243, 1244, 1245, 1246,
  686, 937, 1720, 548, 582, 812, 689, 693, 694, 833, 849, 865, 1119, 1288, 1304,
  2280, 3990, 4013, 4056,
];

export const SK_USER_ID_LIST = [
  3629, 3630, 3631, 3632, 3633, 3634, 3635, 3636, 3637, 3638, 3700, 3773, 3908,
  3970, 3971, 3972, 3973, 3974, 3975, 4002, 3964, 3965, 3966, 3967, 3968, 3969,
];

export const SK_STORE_ID_LIST = [
  1130, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1120, 1121, 1131, 1132, 1133,
  1134, 1102, 1122, 1141, 1104, 1129, 1123, 1124, 1125, 1126, 1110, 1127, 1128,
  1113, 1135, 1136, 1137, 1138, 1139, 1140, 1142, 1143, 1144, 1145, 1146, 1147,
  1148, 1149, 1150, 1151, 1152, 1153, 1166, 1165, 1164, 1163, 1178, 1204, 1201,
  1189, 1205, 1203, 1168, 1179, 1170, 1199, 1197, 1187, 1192, 1198, 1196, 1181,
  1186, 1191, 1200, 1195, 1206, 1188, 1193, 1190, 1162, 1180, 1176, 1182, 1185,
  1202, 1207, 1171, 1172, 1184, 1175, 1183, 1174, 1173, 1169, 1194, 1217, 1261,
  1249, 1242, 1216, 1250, 1243, 1219, 1254, 1259, 1257, 1255, 1251, 1258, 1247,
  1246, 1245, 1222, 1256, 1210, 1209, 1221, 1218, 1269, 1282, 1276, 1277, 1281,
  1273, 1279, 1280, 1278, 1272, 1270, 1274, 1286, 1275, 1285, 1284, 1283, 1271,
  1289, 1293, 1290, 1287, 1291, 1288, 1294, 1292, 1296, 1295, 1289, 1293, 1290,
  1287, 1291, 1288, 1294, 1292, 1295, 1319, 1345, 1330, 1338, 1333, 1326, 1318,
  1324, 1340, 1337, 1336, 1322, 1335, 1320, 1331, 1339, 1342, 1323, 1321, 1317,
  1315, 1310, 1332, 1325, 1346, 1298, 1312, 1300, 1347, 1304, 1343, 1344, 1313,
  1316, 1303, 1309, 1348, 1329, 1328, 1327, 1302, 1311, 1299, 1306, 1314, 1307,
  1308, 1305, 1301, 1341, 1334, 1349, 1089, 1388, 1401, 1402, 1403, 1404, 1405,
  1406, 1407, 1408, 1137, 1138, 1416, 1417, 1418, 1419, 1349, 1416, 1417, 1418,
  1419, 1424, 1425, 1429, 1430, 1431, 1432, 1433, 1434, 1435, 1436, 1437, 1467,
  1465, 1466, 1464, 1455, 1472, 1170, 1468, 1470, 1454, 1460, 1471, 1461, 1457,
  1459, 1458, 1456, 1463, 1469, 1462, 1473, 1467, 1463, 1305,
];

export const DGTAS_USER_ID_LIST = [3615];

export const DGTAS_STORE_ID_LIST = [1083];
